import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import axios from "axios";

import {
  Avatar,
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { IUserResponse } from "../types/user";
import { usePermissions } from "../hooks/permissions";
import PERMISSIONS from "../constants/permissions";

import UserDetails from "../components/UserDetails";
import UserSchedule from "./UserSchedule";

const User: React.FunctionComponent<{}> = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  const canViewSchedule = hasPermission(PERMISSIONS.READ_USER_SCHEDULE_ALL);

  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState<IUserResponse>();
  const [tab, setTab] = useState(0);

  const loadUser = useCallback(() => {
    if (!id) {
      return;
    }
    setIsLoading(true);
    axios
      .get<IUserResponse>(`/users/${id}`)
      .then((res) => {
        setUser(res.data);
      })
      .catch((err) => {
        console.log("err:", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  if (isLoading) {
    return (
      <Stack alignItems="center" sx={{ pt: 8 }}>
        <CircularProgress />
      </Stack>
    );
  }

  if (!user) {
    return <Typography variant="h6">Lietotājs nav atrasts</Typography>;
  }

  return (
    <Stack spacing={2}>
      <Stack direction="row" spacing={2} alignItems="center">
        <IconButton onClick={() => navigate("/users")}>
          <ArrowBackIcon />
        </IconButton>
        <Avatar alt={user.name} src={user.image} />
        <Typography variant="h4">{user.name}</Typography>
      </Stack>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={tab} onChange={(e, value) => setTab(value)}>
          <Tab label="Detaļas" />
          {canViewSchedule && <Tab label="Grafiks" />}
        </Tabs>
      </Box>

      {tab === 0 && (
        <UserDetails
          user={user}
          onChange={(updated) => setUser(updated)}
          onDeleted={() => navigate("/users")}
        />
      )}

      {tab === 1 && canViewSchedule && (
        <UserSchedule userId={user._id} embedded />
      )}
    </Stack>
  );
};

export default User;
